import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import OrderMiniRouteMap from "./OrderMiniRouteMap";
import GoogleRouteMap, { hasGoogleKey } from "./GoogleRouteMap";

const useWatchPos = () => {
  const [pos, setPos] = useState(null);
  useEffect(() => {
    if (!navigator.geolocation) return undefined;
    const id = navigator.geolocation.watchPosition(
      (p) => setPos({ lat: p.coords.latitude, lng: p.coords.longitude }),
      () => {},
      { enableHighAccuracy: true, maximumAge: 5000, timeout: 15000 }
    );
    return () => navigator.geolocation.clearWatch(id);
  }, []);
  return pos;
};

const Tab = ({ active, onClick, children, testId }) => (
  <button onClick={onClick} data-testid={testId}
    className={`px-3 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest transition-colors ${active ? "bg-[#D4AF37] text-black" : "bg-black/60 text-white"}`}>
    {children}
  </button>
);

// Écran partagé « en route » : carte en direct (haut 50%) + détails de la commande (bas 50%)
export default function RouteSplitScreen({ order, dest, onMinimize, children }) {
  const pos = useWatchPos();
  const [mode, setMode] = useState(hasGoogleKey ? "google" : "woma");
  return (
    <div className="fixed inset-0 z-50 bg-[#020617] flex flex-col" data-testid={`route-split-${order.id}`}>
      <div className="relative h-1/2 shrink-0 border-b border-[#D4AF37]/30" data-testid="route-split-map">
        {mode === "google"
          ? <GoogleRouteMap origin={pos} dest={dest} />
          : <OrderMiniRouteMap orderId={order.id} destLat={dest.lat} destLng={dest.lng} destLabel="LIVRAISON" height="100%" />}
        <div className="absolute top-3 left-1/2 -translate-x-1/2 flex gap-2 z-[600]">
          <Tab active={mode === "google"} onClick={() => setMode("google")} testId="route-tab-google">Google Maps</Tab>
          <Tab active={mode === "woma"} onClick={() => setMode("woma")} testId="route-tab-woma">Carte WÔMA</Tab>
        </div>
        <button onClick={onMinimize} data-testid="route-split-minimize"
          className="absolute top-3 right-3 z-[600] w-9 h-9 rounded-full bg-black/60 text-white flex items-center justify-center">
          <ChevronDown className="w-5 h-5" />
        </button>
      </div>
      <div className="h-1/2 overflow-y-auto p-4" data-testid="route-split-details">{children}</div>
    </div>
  );
}
